.panel {
	@apply yst-max-w-md;
}

.body {
	@apply yst-space-y-4 yst-my-6;

	p {
		@apply yst-text-slate-600;
	}
}

.note {
	@apply yst-text-sm yst-text-slate-500 yst-italic;
}

.error {
	@apply yst-mt-4;
}

.actions {
	@apply yst-flex yst-justify-end yst-gap-3;
}
